import {Moment} from 'moment';
import moment from 'moment-timezone';

export const getMomentTime =
    (timestamp: number): Moment => moment.unix(timestamp).tz(window.settings.user.time_zone.full_name);
